import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import getters from './getter'
Vue.use(Vuex)
// 封装状态管理库
const store = new Vuex.Store({
    // state: {},
    // mutations: {},
    // actions: {}
	modules: {
		user
	},
	getters
})
export default store